import useAppDispatch from "../../../hooks/useAppDispatch";
import { useEffect, useRef } from "react";
import { Form, FormInstance } from "antd";
import { useTranslation } from "react-i18next";
import { useGetMaintenanceSettingsQuery, useGetSettingsQuery } from "../../../api/queries";
import { useSettingsMutations } from "../../../api/mutations";
import { openSuccessMessage } from "../../../store/message/messageSlice";
import { handleError } from "../../../helper/errorHandler";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import { IMaintenanceSettings } from "../../../models/MaintenanceSettings";
import FormItemCheckbox from "../../../components/ui/FormItemCheckbox/FormItemCheckbox";

const MaintenanceSettings = () => {
  const dispatch = useAppDispatch();
  const formRef = useRef<FormInstance>(null);
  const { t } = useTranslation();
  const { data: maintenanceSettings } = useGetMaintenanceSettingsQuery();
  const { editMaintenanceSettings } = useSettingsMutations();

  useEffect(() => {
    if (maintenanceSettings && formRef.current) {
      formRef.current.setFieldsValue({
        modeOn: maintenanceSettings.modeOn,
      });
    }
  }, [maintenanceSettings, formRef]);

  const onFinish = (values: Omit<IMaintenanceSettings, "id">) => {
    editMaintenanceSettings(values, {
      onSuccess: () => {
        dispatch(openSuccessMessage(t("SettingsChangedSuccessfully")));
      },
      onError: (e) => handleError(e, dispatch, t),
    });
  };

  return (
    <Form
      ref={formRef}
      className={"form"}
      name="maintenance-settings"
      onFinish={onFinish}
      autoComplete="off"
      layout={"vertical"}
      style={{ width: "500px" }}
    >
      <FormItemCheckbox
        name={"modeOn"}
        label={t("MaintenanceModeOn")}
        rules={{ required: false }}
      />

      <br />
      <CustomButton text={t("SaveChanges")} type={"submit"} typeStyle={"fill"} />
    </Form>
  );
};

export default MaintenanceSettings;
